export default __webpack_public_path__ + "static/media/logo.9533b6e7.webp";